import { render, staticRenderFns } from "./TokenIndex.vue?vue&type=template&id=3fe5d6fe&"
import script from "./TokenIndex.vue?vue&type=script&lang=js&"
export * from "./TokenIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports